
import { useState, useEffect } from 'react';
import { Link, useLocation } from '@tanstack/react-router';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { trackWhatsAppClick } from '@/lib/gtm';


export const menuItems = [
  { label: 'Início', href: '/' },
  { label: 'Sobre Nós', href: '/sobre-nos' },
  { label: 'Produtos', href: '/produtos' },
  { label: 'Blog', href: '/blog' },
  { label: 'Contato', href: '/contato' },
];

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  
  const isHomePage = location.pathname === '/';
  const shouldBeWhite = isScrolled || !isHomePage;

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleBudgetClick = (locationStr: string) => {
    trackWhatsAppClick("Solicitar orçamento", "/orcamento", locationStr);
  };

  return (
    <header className={cn(
      "fixed top-0 left-0 right-0 z-50 transition-all duration-300 px-6",
      shouldBeWhite 
        ? "bg-white/95 backdrop-blur-md shadow-md py-3 border-b border-gray-100" 
        : "bg-transparent py-6 border-b border-transparent"
    )}>
      <div className="container mx-auto flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img src="/logo.png" alt="STOP SOM Logo" width="250" height="64" className="h-14 lg:h-16 w-auto object-contain transition-all" />
        </Link>
        
        <nav className="hidden lg:flex gap-8 font-medium text-base uppercase tracking-wider text-primary">
          {menuItems.map(item => (
            <Link 
              key={item.label} 
              to={item.href} 
              className="hover:text-secondary transition-colors"
              activeProps={{ className: "text-secondary font-bold" }}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <Link 
            to="/orcamento" 
            className="hidden md:flex bg-primary text-white px-6 py-2.5 rounded-full font-bold text-sm uppercase tracking-wide hover:bg-secondary transition-all transform hover:-translate-y-0.5 shadow-lg shadow-primary/20 items-center"
            onClick={() => handleBudgetClick("header")}
            data-gtm-event="whatsapp_click"
            data-conversion="whatsapp"
            data-button-location="header"
          >
            Solicitar orçamento
          </Link>
          <button className="lg:hidden text-primary p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label={isMobileMenuOpen ? "Fechar menu" : "Abrir menu"}>
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <motion.div 
          initial={{ opacity: 0, y: -20 }} 
          animate={{ opacity: 1, y: 0 }} 
          className="absolute top-full left-0 right-0 bg-white border-t border-gray-100 p-6 flex flex-col gap-4 shadow-xl lg:hidden"
        >
          {menuItems.map(item => (
            <Link 
              key={item.label} 
              to={item.href} 
              className="text-xl font-semibold text-primary py-2 border-b border-gray-50 text-center"
              onClick={() => setIsMobileMenuOpen(false)}
              activeProps={{ className: "text-secondary" }}
            >
              {item.label}
            </Link>
          ))}
          <Link 
            to="/orcamento" 
            className="bg-primary text-white text-center py-4 rounded-xl font-bold mt-2 flex items-center justify-center"
            onClick={() => {
              setIsMobileMenuOpen(false);
              handleBudgetClick("header-mobile");
            }}
            data-gtm-event="whatsapp_click"
            data-conversion="whatsapp"
            data-button-location="header-mobile"
          >
            Solicitar orçamento
          </Link>
        </motion.div>
      )}
    </header>
  );
};
